import React from 'react';
import $ from 'jquery';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

class Main extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      name: localStorage.getItem("userName") || "",
      number: localStorage.getItem("userNumber") || "",
      email: props.userMail || "",
      pickuplocation: localStorage.getItem("pickuplocation") || "37 miltary hospital",
      destination: localStorage.getItem("destination") || "37 miltary hospital",
      budget: "",
      description: "",
      riderNumber: "",
      sent: false,
      otp: "",
      finished: false,
      showInfo: localStorage.getItem("numberVerified") || false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleToken = this.handleToken.bind(this);
    this.handleAlreadyVerified = this.handleAlreadyVerified.bind(this);
  }

  finish() {

  }

  handleChange(event) {
    if (!this.state.email) {
      this.setState({
        email: this.props.userMail
      })
    }

    let { id, value } = event.target;
    this.setState({ [id]: value });
  }

  handleSubmit() {
    //save info to local storage
    localStorage.setItem("userName", this.state.name);
    localStorage.setItem("userNumber", this.state.number);
    localStorage.setItem("pickuplocation", this.state.pickuplocation);
    localStorage.setItem("destination", this.state.destination);

    //check necessary inputs
    //checking

    if (this.state.name == undefined || this.state.name == "") {
      document.getElementById("info").innerHTML = "Enter your name";
      setTimeout(() => { document.getElementById("name").scrollIntoView({ behavior: "smooth", block: "center" }) }, 2000);
      return;
    }

    if (this.state.number == undefined || this.state.number == "" || this.state.number.length < 10) {
      document.getElementById("info").innerHTML = "Enter your number";
      setTimeout(() => { document.getElementById("number").scrollIntoView({ behavior: "smooth", block: "center" }) }, 2000);
      return;
    }

    let email = this.state.email;
    let filter = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/;

    if (!filter.test(email)) {
      document.getElementById("info").innerHTML = "Enter your email";
      setTimeout(() => { document.getElementById("email").scrollIntoView({ behavior: "smooth", block: "center" }) }, 2000);
      return;
    }

    if (this.state.budget.includes("-")) {
      document.getElementById("info").innerHTML = "Budget must be a number";
      setTimeout(() => { document.getElementById("budget").scrollIntoView({ behavior: "smooth", block: "center" }) }, 2000);
      return;
    }

    //submit to api
    if (this.state.sent) return;
    this.setState({ sent: true });
    document.getElementById("send").innerHTML = "sending...";

    let data = {
      name: this.state.name,
      number: this.state.number,
      email: this.state.email,
      pickuplocation: this.state.pickuplocation,
      destination: this.state.destination,
      budget: this.state.budget,
      description: this.state.description,
    }

    let settings = {
      "async": true,
      "crossDomain": true,
      "url": `https://deliveryapi-3765.herokuapp.com/api/users/request`,
      "method": "POST",
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      "data": data
    }

    $.ajax(settings).done(function (response) {
      //done
      $("#sent-modal-main").css({ "display": "block" });
      document.getElementById("send").innerHTML = "Done";
      this.setState({ finished: true });

    }.bind(this)).fail(function (xhr, status, error) {
      // error handling
      document.getElementById("send").innerHTML = "Error";
    });
  }

  handleToken() {
    document.getElementById("sendotp").innerHTML = "sending...";

    let data = {
      otp: this.state.otp,
    }

    let settings = {
      "async": true,
      "crossDomain": true,
      "url": `https://deliveryapi-3765.herokuapp.com/api/users/verify`,
      "method": "POST",
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      "data": data
    }

    $.ajax(settings).done(function (response) {
      //done
      //Number now verified
      document.getElementById("sendotp").innerHTML = "Done";
      localStorage.setItem("numberVerified", true);
      this.setState({ showInfo: true });
    }.bind(this)).fail(function (xhr, status, error) {
      // error handling
      document.getElementById("sendotp").innerHTML = "Error";
      setTimeout(() => document.getElementById("sendotp").innerHTML = "verify", 3000);
    });
  }

  componentDidMount() {
    document.getElementById("start").scrollIntoView({ behavior: "smooth", block: "center" });

    let settings = {
      "async": true,
      "crossDomain": true,
      "url": `https://deliveryapi-3765.herokuapp.com/api`,
      "method": "GET",
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }

    $.ajax(settings).done(function (response) {
      //done

    });
  }

  handleAlreadyVerified() {
    localStorage.setItem("numberVerified", true);
    this.setState({ showInfo: true });
  }

  render() {
    return (
      <section>
        <div className="header-05 container container--large header-07__container">
          <div className="header-07__left">
            <div className="header-07__left_content">
              <h1 className="heading heading--accent header-07__heading">Your Riders await you.</h1>
              <p className="header-07__text">Provide the necessary details then sit back and relax.</p>
              <div className="header-07__buttons_box header-07__cta_box">
                <div className="buttons-set">
                  <ul className="buttons-set__list">
                    <li className="buttons-set__item"><Link to="/" className="button   button--accent-bg "
                    >Home</Link>
                    </li>
                    <li className="buttons-set__item">
                      <Link to="/signup" className="button button--accent-outline state-active" type="button">Join the team </Link>
                    </li>
                  </ul>
                  <div className="score">
                    <div className="score__stars"><img className="score__star" src="img/icons/star--blue.svg" /><img
                      className="score__star" src="img/icons/star--blue.svg" /><img className="score__star"
                        src="img/icons/star--blue.svg" /><img className="score__star" src="img/icons/star--blue.svg" /><img
                        className="score__star" src="img/icons/star--1-4--blue.svg" /></div>
                    <div className="score__text"><span className="score__word">Based on 15+ <br /><a
                      href="https://www.producthunt.com" target="_blank">Product Hunt </a><br />
                      reviews.</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header-07__right">
            <div className="header-07__img_box"><img className="header-07__img" src="img/other/model.jpg" alt="model" /></div>
          </div>
        </div>

        {!this.state.finished ? (
          <div className="cta_button-01">
            <div className="container container--mid">
              <div className="title-box title-box--center">
                <div className="subheading white-text">Request for a rider today</div>
                <h2 className="heading white-text">Kindly fill the form</h2>
                <p className="title-box__text white-text" id="start">This will be saved so you won't need to repeat basic information next time.</p>
              </div>
            </div>

            <div className="delivery-input">
              <input id="name" className="text-input js-name-input" type="name" name="name" placeholder="Enter your First and Last Name"
                onChange={this.handleChange} value={this.state.name} />

              <input id="number" maxLength="10" className="text-input js-number-input" type="number" name="number" placeholder="Enter your phone number"
                onChange={this.handleChange} value={this.state.number} />

              <input id="email" className="text-input js-email-input" type="email" name="EMAIL" placeholder="Enter your Email"
                onChange={this.handleChange} value={this.state.email} disabled />

              <p>Select your location or the nearest to your location</p>
              <select id="pickuplocation" className="text-input" style={{ width: 260, padding: 10, borderRadius: 15 }}
                onChange={this.handleChange} value={this.state.pickuplocation}>
                <option value='37 miltary hospital'> 37 miltary hospital</option>
                <option value="Accra Central">Accra Central </option>
                <option value='Adenta'>Adenta</option>
                <option value='Achimota'>Achimota</option>
                <option value='Ablekuma'>Ablekuma</option>
                <option value='Circle'>Circle</option>
                <option value='Cantoments'>Cantoments</option>
                <option value='Dome'>Dome</option>
                <option value='Eastlegon'>Eastlegon</option>
                <option value='Haatso'>Haatso</option>
                <option value='Legon Campus'>Legon Campus</option>
                <option value='Labadi'>Labadi</option>
                <option value='Madina'>Madina</option>
                <option value='Nima'>Nima</option>
                <option value='Osu'>Osu</option>
                <option value='Spintex'>Spintex</option>
                <option value='Shiashie'>Shiashie</option>
                <option value='Tema'>Tema</option>
                <option value='UPSA Campus'>UPSA Campus</option>
              </select>

              <p>Select the destination or the nearest to the destination</p>
              <select id="destination" className="text-input" style={{ width: 260, padding: 10, borderRadius: 15 }}
                onChange={this.handleChange} value={this.state.destination}>
                <option value='37 miltary hospital'> 37 miltary hospital</option>
                <option value="Accra Central">Accra Central </option>
                <option value='Adenta'>Adenta</option>
                <option value='Achimota'>Achimota</option>
                <option value='Ablekuma'>Ablekuma</option>
                <option value='Circle'>Circle</option>
                <option value='Cantoments'>Cantoments</option>
                <option value='Dome'>Dome</option>
                <option value='Eastlegon'>East Legon</option>
                <option value='Haatso'>Haatso</option>
                <option value='Legon Campus'>Legon Campus</option>
                <option value='Labadi'>Labadi</option>
                <option value='Madina'>Madina</option>
                <option value='Nima'>Nima</option>
                <option value='Osu'>Osu</option>
                <option value='Spintex'>Spintex</option>
                <option value='Shiashie'>Shiashie</option>
                <option value='Tema'>Tema</option>
                <option value='UPSA Campus'>UPSA Campus</option>
              </select>

              <p>Enter your budget (optional)</p>
              <span>GHC </span><input className="text-input" style={{ width: 80 }} type="number" id="budget"
                name="budget" onChange={this.handleChange} value={this.state.budget} />

              <input className="text-input" id="description"
                placeholder="Comment (optional).   Ex: Item is a large wedding cake."
                onChange={this.handleChange} value={this.state.description}
              />

            </div>

            <div className="container container--small">
              <div className="cta_button-01__button_box">
                <div className="cta_button-01__button_wrapper">
                  <div className="cta_button-01__tag"><span className="tag   tag--night"><span className="tag__text">let us serve you</span></span>
                  </div><button onClick={this.handleSubmit} id="send" className="button button--large  button--alt-accent-bg "><span>Get your Rider</span></button>

                  <p id="info" style={{ color: "white", fontWeight: "bold" }}></p>
                  <p id="info2"></p>
                </div>
              </div>
            </div>
          </div>

        ) : (

            <div className="cta_button-01">
              <div className="container container--mid">
                <div className="title-box title-box--center">
                  <div className="subheading white-text">Parcels Today</div>
                  <h2 className="heading white-text">Thank you for choosing Us</h2>

                  {!this.state.showInfo ? (
                    <div id="token" style={{ background: "white", padding: 25, borderRadius: 15 }}>
                      <p>NB: If you are a new user you must verify your number. Our team will not receive requests from unverified numbers</p> <hr /><p> A token has been sent to {this.state.number}</p>

                      <div id="tokenInput">
                        <input className="text-input" type="text" id="otp" name="otp" required placeholder="Enter Token"
                          onChange={this.handleChange} value={this.state.otp} />
                        <button id="sendotp" type="button" onClick={this.handleToken} className="button button--large button--alt-accent-bg"><span
                          className="glyphicon glyphicon-cloud"></span>
                          verify</button><br /><br />
                      </div>

                      <p>Already did this? </p><button className="button" type="button" onClick={this.handleAlreadyVerified} style={{ borderRadius: 5 }}>
                        Click here and we won't show this to you again</button>
                    </div>
                  )
                    : (
                      <div>
                        <p className="title-box__text white-text" id="start">Our team will review your request.<br /> You will receive an email at {this.state.email} once your request is reviewed.<br /><br />
                          <span style={{ fontWeight: "bold" }}>You can use our Rider Checker on the home page to verify the riders who call you.</span></p>
                        <p>♡ from Parcels Today</p>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          )}

      </section>
    )
  }
}

export default Main;